
import { Button } from "@/components/ui/button";
import WaitlistForm from "./WaitlistForm";
import { ChevronDown } from "lucide-react";
import { useRef } from "react";

const Hero = () => {
  const emailInputRef = useRef<HTMLInputElement>(null);
  
  const scrollToTestimonials = () => {
    document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToBotShowcase = () => {
    document.getElementById('example-bots')?.scrollIntoView({ behavior: 'smooth' });
  };

  const focusEmailInput = () => {
    emailInputRef.current?.focus();
  };

  return (
    <section className="relative min-h-screen flex flex-col">
      {/* Background Chart Image - Full Screen */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0" 
        style={{ 
          backgroundImage: "url('/lovable-uploads/8e470baa-a652-4eae-ab58-db21d6658b4a.png')",
          backgroundSize: "150%", 
          backgroundPosition: "center",
          filter: "brightness(0.9)"
        }}
      ></div>
      
      {/* Content Container - Proper spacing for mobile */}
      <div className="relative z-10 flex-grow flex flex-col items-center justify-center px-4 text-white pt-24 md:pt-16 lg:pt-0">
        <div className="space-y-4 md:space-y-6 mb-6 md:mb-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-center max-w-5xl tracking-wider leading-tight">
            Turn Crypto's Daily 5% Swings 
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-center max-w-5xl tracking-wider leading-tight">
              Into Your Monthly 20% Income
          </h2>
        </div>
        
        <p className="text-base sm:text-lg md:text-xl text-center max-w-2xl mb-6 md:mb-8 text-gray-200 px-2">
         Free workshop reveals the gridbot system earning up to 1% daily & more— without watching charts
        </p>
        
        {/* Email Capture Form */}
        <div id="waitlist-form" className="w-full max-w-md mx-auto">
          <WaitlistForm ref={emailInputRef} />
          <p className="text-center text-sm mt-2 text-gray-300">We respect your privacy</p>
        </div>
        
        {/* Explanatory Text - positioned in blank space */}
        <div className="mt-6 pb-3 text-center">
          <p className="text-sm sm:text-base text-gray-200">
            Say 0.5%~1%+ daily returns: Turn $5K into $25-$50+/day. That's ~$750 to $1,500+/month{" "}
            <span 
              className="text-blue-400 hover:text-blue-300 cursor-pointer transition-colors duration-200"
              onClick={focusEmailInput}
            >
              Learn how ↑
            </span>
            <br />
            During high volatility, the yield often exceeds that! See screenshots{" "}
            <span 
              className="text-blue-400 hover:text-blue-300 cursor-pointer transition-colors duration-200"
              onClick={scrollToBotShowcase}
            >
              below
            </span>
          </p>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div 
        className="relative z-10 flex justify-center pb-8 animate-bounce cursor-pointer" 
        onClick={scrollToTestimonials}
      >
        <ChevronDown className="h-8 w-8 text-white opacity-75" />
      </div>
    </section>
  );
};

export default Hero;
